import {Component, HostListener, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormControl, FormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {ButtonStyle} from '../../components/ui/text-button/text-button.component';
import {RoutingService} from '../../original-services/routing.service';
import {RestoreDataService} from '../../original-services/restore-data.service';
import {PASSWORD_PATTERN} from '../../common/patterns';
import {LoggerService} from '../../original-services/logger.service';
import {STATE_NAMES} from '../../common/state-names';

@Component({
    selector: 'page-resent-password',
    templateUrl: './resent-password.component.html',
    styleUrls: ['./resent-password.component.scss'],
    standalone: false
})
export class ResentPasswordPageComponent implements OnDestroy {
    token: string;
    uid: string;
    buttonStyle = ButtonStyle;
    submitPressed = false;
    isSubmitting = false;
    errorMessage?: string;
    successMessage?: string;
    formGroup = new FormGroup<any>({});

    private passwordChangesSubscription: Subscription;

    get newPassword(): FormControl {
        return this.formGroup.get('new_password') as FormControl;
    }

    constructor(
        private routingService: RoutingService,
        private fb: UntypedFormBuilder,
        private restoreService: RestoreDataService,
        private logger: LoggerService
    ) {
        this.uid = this.routingService.params['param1'];
        this.token = this.routingService.params['param2'];
        this.formGroup = this.fb.group({
            new_password: [null, [
                Validators.required,
                Validators.minLength(6),
                Validators.pattern(PASSWORD_PATTERN)]
            ]
        });

        // Clears only the server message; the format error is driven by the control's own
        // validity, so it stays visible until the value matches the pattern.
        this.passwordChangesSubscription = this.newPassword.valueChanges.subscribe(() => {
            this.errorMessage = undefined;
        });
    }

    @HostListener('document:keydown.enter')
    onKeyEnter() {
        this.changePassword();
    }

    changePassword() {
        // Enter fires this twice (keydown listener + the form's implicit submit); the guard
        // also blocks a resubmit while the post-success redirect is pending.
        if (this.isSubmitting || this.successMessage) {
            return;
        }
        this.submitPressed = true;
        if (this.formGroup.valid) {
            this.errorMessage = undefined;
            this.isSubmitting = true;
            this.submitForm();
        }
    }

    submitForm() {
        const params = this.formGroup.value;
        params['uidb64'] = this.uid;
        params['token'] = this.token;
        this.restoreService.sendPassword(params)
            .subscribe({
                next: () => {
                    this.isSubmitting = false;
                    this.successMessage = `ResetPassword.Form.Success`;
                    setTimeout(() => {
                        this.redirectToSignup()
                    }, 3000);
                },
                error: (error: any) => {
                    this.isSubmitting = false;
                    this.logger.error(error);
                    this.errorMessage = `ResetPassword.Form.ErrorDefault`;
                }
            })
    }

    redirectToSignup() {
        this.routingService.go(STATE_NAMES.login);
    }

    ngOnDestroy() {
        if (this.passwordChangesSubscription) {
            this.passwordChangesSubscription.unsubscribe();
        }
    }

}
